export default __webpack_public_path__ + "static/behavioral-automation-saas-cf2138d8b6e51cf05b63f8361154767d.png";